import React, { useMemo, useState } from "react";

import { parseUnitObjective } from "@examspark/api";
import { VSpace } from "@examspark/common-ui";
import { getObjectiveCurriculumUsage } from "@examspark/customer/tcmpc";
import {
  ParsedTCMPCUnit,
  TeksCurriculumUsage,
  TeksCurriculumUsageList,
} from "@examspark/types";

import Objectives from "../common/Objectives";
import {
  filterObjectivesItems,
  ObjectiveFilterState,
  ObjectivesFilter,
} from "../objectives/ObjectivesFilter";

const excludedUsages: Array<TeksCurriculumUsage | undefined> = ["ONGOING"];

const UnitObjectives = ({
  unit,
}: {
  unit: ParsedTCMPCUnit | null | undefined;
}) => {
  const [filterOptions, setFilterOptions] = useState<ObjectiveFilterState>([
    { type: "usages", label: "", value: "DIRECTLY_TAUGHT" },
    { type: "usages", label: "", value: "DEVELOPING" },
  ]);

  const filteredObjectives = useMemo(
    () =>
      filterObjectivesItems(filterOptions, unit?.objectives ?? [])
        .filter((o) => !excludedUsages.includes(getObjectiveCurriculumUsage(o)))
        .map((objective) => parseUnitObjective(objective)),
    [filterOptions, unit],
  );

  return (
    <VSpace size="2rem" style={{ marginTop: "1rem" }}>
      <Objectives
        objectives={filteredObjectives ?? []}
        unit={unit}
        toolbar={
          <ObjectivesFilter
            filterOptions={filterOptions}
            setFilterOptions={setFilterOptions}
            filtersFor="objectivesItems"
            availableUsages={TeksCurriculumUsageList.filter(
              (value) => !excludedUsages.includes(value),
            )}
          />
        }
      />
    </VSpace>
  );
};

export default UnitObjectives;
